import React from 'react';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles/main.scss';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const LOGIN_PATH = '/79834yhbdgyt562xa';

axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && localStorage.getItem('admToken')) {
      localStorage.removeItem('admToken');
      localStorage.removeItem('user');
      window.location.href = LOGIN_PATH;
    }
    return Promise.reject(err);
  }
);

const container = document.getElementById('root');


const root = createRoot(container);

root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Pantalla de carga con el logo (public/index.html): se desvanece cuando la página
// terminó de cargar, pero se muestra al menos 800 ms para que no sea un parpadeo.
const SPLASH_MIN_MS = 800;
const hideSplash = () => {
  const splash = document.getElementById('splash');
  if (!splash) return;
  const wait = Math.max(0, SPLASH_MIN_MS - performance.now());
  setTimeout(() => {
    splash.classList.add('splash--hide');
    splash.addEventListener('transitionend', () => splash.remove(), { once: true });
  }, wait);
};
if (document.readyState === 'complete') hideSplash();
else window.addEventListener('load', hideSplash, { once: true });
